/**
 * description CDN의 리소스를 가져오는 유틸함수
 * @see https://yanolja.atlassian.net/wiki/spaces/FES/pages/103752510/FES+CDN
 */
export const getImage = (path: string): string => {
  return `//yaimg.yanolja.com/joy/sunny${path}`;
};
